import { apiWrapper } from './helpers';

export function zeroBounceValidate(email) {
    return apiWrapper(
        `/consumer/v1/users/email-validation?email=${email}`,
        'GET',
        'CHECK SINGLE EMAIL'
    );
}
